import {useState} from 'react';

import {Blob} from 'activestorage';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import ImageUploader from 'components/ImageUploader/ImageUploader';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import cloneDeep from 'lodash.clonedeep';
import {setErrorAC} from 'store/app/appSlice';
import {setModalAC} from 'store/modal/modalSlice';
import {updateUserInfoACS} from 'store/profile/requestAC';

import './UploadPhoto.scss';

const UploadPhoto: React.FC = () => {
  const profileInfo = cloneDeep(useGlobalState((state) => state.profile.profileInfo)!);
  const [imageName, setImageName] = useState('');
  const [imageBlob, setImageBlob] = useState<any>();

  const dispatch = useSetGlobalState();

  const handleCloseModal = () => {
    dispatch(setModalAC(null));
  };

  const onAddPhoto = (blob: Blob, files: File[], allowedFileTypes: string[]) => {
    const file = files[0];
    const fileType = file?.name?.split('.')?.pop()?.toLowerCase();

    if (!allowedFileTypes.includes(fileType!)) {
      const fileName = file.name;
      const errorText = `The specified file
        ${fileName}
         could not be uploaded. The image is invalid or not supported.
       Allowed types: png, jpeg, gif, jpe, jpg`;

      return setErrorAC(errorText);
    }
    setErrorAC(null);
    return setImageBlob(blob);
  };

  const onSaveImage = () => {
    if (imageBlob) {
      const imageId = imageBlob.signed_id;
      profileInfo.profile_image = imageId;

      dispatch(updateUserInfoACS(profileInfo));
      dispatch(setModalAC(null));
    }
  };

  return (
    <div className="upload-photo">
      <div className="upload-photo__header">
        <div className="upload-photo__title">
          <Text tag="span">UPLOAD PHOTO</Text>
        </div>
        <div className="upload-photo__close" role="button" onClick={handleCloseModal}>
          <Icon icon="close" />
        </div>
      </div>
      <div className="upload-photo__upload">
        <ImageUploader setImageName={setImageName} callback={onAddPhoto}>
          <div className="upload-photo__uploader">
            <Icon icon="download" />
            <Text tag="h5">Drag and Drop</Text>
            <Text tag="span">or</Text>
            <Button variant="dark">Browse Photo</Button>
            <Text tag="p" className="upload-photo__image-name">
              {imageName}
            </Text>
          </div>
        </ImageUploader>
        <div className="upload-photo__buttons">
          <Button variant="text" onClick={handleCloseModal}>
            Cancel
          </Button>
          <div className="upload-photo__divider" />
          <Button variant="dark" disabled={imageName === ''} onClick={onSaveImage}>
            Save as Profile Photo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UploadPhoto;
